// Permission codes — must match oms.security.Permissions and V14__rbac.sql.
// The UI uses these only to decide what to show; the backend enforces them.
export const PERMISSIONS = Object.freeze({
  ADMIN_TOOLS: 'ADMIN_TOOLS',
  ANALYTICS_VIEW: 'ANALYTICS_VIEW',
  COSTSHEET_APPROVE: 'COSTSHEET_APPROVE',
  COSTSHEET_MANAGE_ALL: 'COSTSHEET_MANAGE_ALL',
  COSTSHEET_VIEW_ALL: 'COSTSHEET_VIEW_ALL',
  INVOICE_DELETE: 'INVOICE_DELETE',
  LEAD_DELETE: 'LEAD_DELETE',
  VENDOR_CATALOG_MANAGE: 'VENDOR_CATALOG_MANAGE',
});
